/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ProcurementFilter.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ProcurementFilter } from "./ProcurementFilter";

import { ProcurementFilterTeam } from "./ProcurementFilterTeam";
import { Project } from "./Project";
import { User } from "./User";

export abstract class ProcurementFilterModel {
    id: number;
    createdAt: Dayjs;
    name: string;
    orderStatus: string[] | null;
    projectId: number;
    textSearch: string | null;
    updatedAt: Dayjs;
    userId: number;
    receivingTeams: any | null;
    vendors: any | null;
    procurementFilterTeams: ProcurementFilterTeam[] | undefined;
    project: Project | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        name: string,
        orderStatus: string[] | null,
        projectId: number,
        textSearch: string | null,
        updatedAt: Dayjs,
        userId: number,
        receivingTeams: any | null,
        vendors: any | null,
        procurementFilterTeams: ProcurementFilterTeam[] | undefined,
        project: Project | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.name = name;
        this.orderStatus = orderStatus;
        this.projectId = projectId;
        this.textSearch = textSearch;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.receivingTeams = receivingTeams;
        this.vendors = vendors;
        this.procurementFilterTeams = procurementFilterTeams;
        this.project = project;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): ProcurementFilter {
        const newObject = new ProcurementFilter(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["name"],
            json["order_status"],
            json["project_id"],
            json["text_search"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["receiving_teams"],
            json["vendors"],
            json["procurement_filter_teams"]?.map((item: any) => ProcurementFilterTeam.fromApiObject(item, timezone)),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            created_at: this.createdAt,
            name: this.name,
            order_status: this.orderStatus,
            project_id: this.projectId,
            text_search: this.textSearch,
            updated_at: this.updatedAt,
            user_id: this.userId,
            procurement_filter_teams_attributes: this.procurementFilterTeams
                ?.map((item) => item.toApiObject(visited))
                .filter((item) => item !== undefined),
            project_attributes: this.project?.toApiObject(visited),
            user_attributes: this.user?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ProcurementFilter {
        const clone = Object.create(this) as ProcurementFilter;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
